import { useEffect } from 'react';
import './../../stylesheets/events.css';
import { Outlet } from 'react-router-dom';

const Events = (props) => {
  useEffect(() => {
    props.setOnPage(2);
  }, [props]);

  return (
    <div className='events-wrapper'>
      <Outlet />
    </div>
  );
};

export default Events;
